import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BaseRestService } from "./base-rest.service";
import {LoanNotes} from "@app/models/loan-notes";
import { GuaranteeNotes } from "@app/models/guarantee-notes";

@Injectable({
    providedIn: 'root'
})
export class GuaranteeAgreementNotesService extends BaseRestService {

    readonly GUARANTEE_NOTE_URL: string = environment.loanUri + '/guarantee-notes';

    getList(pageParams: any): Observable<any> {
        const options = {
            headers: this.headers,
            params: this.removeEmptyPropertyFromObject(pageParams)
        }
        return this.httpClient.get(this.GUARANTEE_NOTE_URL, options);
    }

    getGuaranteeById(id): Observable<any> {
        const options = {
            headers: this.headers
        }
        return this.httpClient.get(this.GUARANTEE_NOTE_URL + '/' + id, options);
    }

    create(data: LoanNotes): Observable<any> {
        return this.httpClient.post(this.GUARANTEE_NOTE_URL, JSON.stringify(data),
            { headers: this.headers });
    }

    update(accountType: LoanNotes): Observable<any> {
        return this.httpClient.put(this.GUARANTEE_NOTE_URL + '/' + accountType.id, JSON.stringify(accountType),
            { headers: this.headers });
    }

    delete(id: string): Observable<any> {
        return this.httpClient.delete(this.GUARANTEE_NOTE_URL + "/" + id,
            { headers: this.headers });
    }

    findGuaranteeNoteParents(guaranteeNote: GuaranteeNotes, guaranteeNotes: Array<GuaranteeNotes>) {
        let items = [];
        if (guaranteeNote) {
          items.push(guaranteeNote);
          if (guaranteeNotes && guaranteeNotes.length > 0) {
            var parentItem = this.findGuaranteeNoteById(guaranteeNote.parentId, guaranteeNotes);
            if (parentItem) {
              items = items.concat(this.findGuaranteeNoteParents(parentItem, guaranteeNotes));
            }
          }
        }
        return items;
    }

    findGuaranteeNoteById(id: string, items: Array<GuaranteeNotes>) {
        if (id) {
          if (items && items.length > 0) {
            var item = items.find((p) => p.id == id);
            if (item) {
              return item;
            }

            for (var i = 0; i < items.length; i++) {
              var item = this.findGuaranteeNoteById(id, items[i].subGuaranteeNotes);
              if (item) {
                return item;
              }
            }
          }
        }
        return undefined;
    }
}